export default __webpack_public_path__ + "static/media/almond-3S.0dec939f.webp";